import angular from 'angular';
import fbLiCtrl from '../fb-li/fb-li.controller'

let fbLiSelect = {
  template: require('./fb-li-select.html'),
  require: {
    fbOlSelectCtrl: '^fbOlSelect'
  },
  bindings: {
    /* 
      Bindings are bound to controller object (this.value)
      Flow: Data down, events up
      Data:
      '<' - one-way data binding that should not be mutated (value)
      Events: 
      '&' - callback for a component event (onUpdate(newValue))
      Comments:
      '@' - static strings (label)
    */
    name: '@',
    selection: '<',
    value: '<',
    onUpdate: '&',
    onSelect: '&',
    onCreate: '&'
  },
  controller: fbLiCtrl
}

export default angular.module('components.fbLiSelect', [])
  .component('fbLiSelect', fbLiSelect)
  .name;



// WEBPACK FOOTER //
// ./project/components/fb-li-select/index.js